/**
 *  This attaches event handler to deal with communication between
 *  third party domains and our widgets embedded in iframes.
 */

import { getReferrerFromQuery } from 'lib/widgetHelpers';

const referrer = getReferrerFromQuery(window.location.search);
const injectedData = {};

window.addEventListener('message', (e) => {
  if (!e.data || !e.data.action) {
    return;
  }
  switch (e.data.action) {
    case 'set': {
      const { key, value } = e.data;
      if (typeof key === 'string') {
        injectedData[key] = value;
      }
      break;
    }
    case 'remove': {
      const { key } = e.data;
      if (typeof key === 'string') {
        delete injectedData[key];
      }
      break;
    }
    default:
  }
  sessionStorage.setItem(`ao-${referrer}`, JSON.stringify(injectedData));
});
